import { render, staticRenderFns } from "./AdminShirazPaidOrder.vue?vue&type=template&id=ba1153c6&scoped=true"
import script from "./AdminShirazPaidOrder.vue?vue&type=script&lang=js"
export * from "./AdminShirazPaidOrder.vue?vue&type=script&lang=js"
import style0 from "./AdminShirazPaidOrder.vue?vue&type=style&index=0&id=ba1153c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1153c6",
  null
  
)

export default component.exports